import "../css/bootstrap.css";
import "../css/afroEsteticaCarrossel.css";
import ae1 from "../img/AE1.jpg";
import ae2 from "../img/AE2.jpg";
import ae3 from "../img/AE3.jpg";
import ae4 from "../img/AE4.jpg";
import ae5 from "../img/AE5.jpg";
import ae6 from "../img/AE6.jpg";
import ae7 from "../img/AE7.jpg";
import ae8 from "../img/AE8.jpg";
import ae9 from "../img/AE9.jpg";
import ae10 from "../img/AE10.jpg";
import ae11 from "../img/AE11.jpg";
import ae12 from "../img/AE12.jpg";
import ae13 from "../img/AE13.jpg";
import ae14 from "../img/AE14.jpg";
import ae15 from "../img/AE15.jpg";
import ae16 from "../img/AE16.jpg";
import ae17 from "../img/AE17.jpg";
import ae18 from "../img/AE18.jpg";
import ae19 from "../img/AE19.jpg";
import ae20 from "../img/AE20.jpg";
import ae21 from "../img/AE21.jpg";
import ae22 from "../img/AE22.jpg";
import ae23 from "../img/AE23.jpg";
import ae24 from "../img/AE24.jpg";
import ae25 from "../img/AE25.jpg";

function AfroEsteticaCarrossel() {
  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide"
      data-ride="carousel"
    >
      <ol className="carousel-indicators">
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="0"
          className="active"
        ></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="7"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="8"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="9"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="10"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="11"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="12"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="13"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="14"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="15"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="16"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="17"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="18"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="19"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="20"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="21"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="22"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="23"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="24"></li>
      </ol>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img className="d-block w-100 imgs2" src={ae1} alt="First slide" />
          <div className="carousel-caption">
            <h5>Afrofuturo e estetica</h5>
            <p>
              A estética afrofuturista se pauta no vislumbre de um futuro preto
              estruturado e enraizado em sua potência ancestral. Ou seja,
              olhando para o seu passado para que só então seja possível
              construir um futuro. Esse pensamento converge com um símbolo
              Adinkra chamado Sankofa, que é representado por um pássaro
            </p>
          </div>
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae2} alt="Second slide" />
          <div className="carousel-caption">
            <p>
              Na moda, a estética afrofuturista se faz muito presente não só nos
              figurinos de grandes filmes, mas, também, em produções musicais
              como as da cantora Beyoncé, por exemplo, que em Black Is King –
              seu mais recente trabalho – resgata inúmeras referências
              ancestrais aplicadas em um material audiovisual potente e que se
              tornou um grande divisor de águas na música e na moda atuais.ho de
              Senghor e de outros pensadores africanos contemporâneos.
            </p>
          </div>
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae3} alt="Third slide" />
          <div className="carousel-caption">
            <h5>Um pouco mais...</h5>
            <p>
              Criado como expressão artística e cultural na década de 1960, o
              afrofuturismo possui várias faces. De movimento social e político
              a uma plataforma de conexão entre tecnologia e ciência inspirada
              na ancestralidade africana. São inúmeros os artistas, no Brasil e
              no mundo, que se inspiram na estética afrofuturista. Mas foi na
              cultura pop, mais especificamente no cinema, que o movimento
              começou a ganhar expressão para o mainstream, a partir da década
              de 1990. A estreia de Pantera Negra, em 2018, elevou as buscas
              pelo termo. Mas antes, em 1999, Matrix já se inspirava no
              movimento com o personagem Zygon Morpheus. No final de 2020, a
              Disney anunciou uma parceria com a Kugali Media para a produção da
              série nigeriana Iwajú, prevista para 2022.
            </p>
          </div>
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae4} alt="Quarto slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae5} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae6} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae7} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs3" src={ae8} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae9} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae10} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae11} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae12} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae13} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae14} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae15} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae16} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae17} alt="Third slide" />
          <div className="carousel-caption">
            <h5>Curiosidades</h5>
            <p>
              A estreia de Pantera Negra, em 2018, elevou as buscas pelo termo.
              Mas antes, em 1999, Matrix já se inspirava no movimento com o
              personagem Zygon Morpheus. No final de 2020, a Disney anunciou uma
              parceria com a Kugali Media para a produção da série nigeriana
              Iwajú, prevista para 2022.
            </p>
          </div>
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae18} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae19} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae20} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae21} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae22} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae23} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae24} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100 imgs2" src={ae25} alt="Third slide" />
        </div>
      </div>
      <a
        className="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a
        className="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  );
}

export default AfroEsteticaCarrossel;
